import { useDispatch } from 'react-redux';
import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';
import { updateFavourite } from '@noths/polaris-client-user-favourites';
import getConfig from 'next/config';

import { actions } from 'src/redux/productMediaCarousel/slice';
import type { AppThunkDispatch } from 'src/redux/store';
import type { NextConfig } from 'src/types/nextConfig';
import type { ProductMediaCarouselProps } from './ProductMediaCarousel';

// Every handler the carousel accepts, all non-optional: the hook always supplies them, so
// consumers spreading it never have to null-check what the component types as optional.
type ProductMediaCarouselConcreteActions = Required<
  Pick<
    ProductMediaCarouselProps,
    | 'onFavouriteClick'
    | 'onNextMedia'
    | 'onOpenModal'
    | 'onPrevMedia'
    | 'onVisible'
    | 'setCurrentMedia'
  >
>;

export const useProductMediaCarouselActions = (): ProductMediaCarouselConcreteActions => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const nextConfig = getConfig() as NextConfig;

  return {
    onFavouriteClick: (productCode) => dispatch(updateFavourite({ productCode, nextConfig })),
    onNextMedia: (payload) => dispatch(actions.nextMedia(payload)),
    onOpenModal: (payload) => dispatch(actions.openModal(payload)),
    onPrevMedia: (payload) => dispatch(actions.prevMedia(payload)),
    onVisible: ({ totalMedia }) => {
      deferTracking(() =>
        sendGAEvent({
          event: 'custom_event',
          event_category: 'Media carousel',
          event_action: 'Impression',
          event_label: String(totalMedia),
        }),
      );
    },
    setCurrentMedia: (payload) => dispatch(actions.setCurrentMedia(payload)),
  };
};
